

export function deepMerge<T>(target: T, source: Partial<T>): T {
    if (typeof target !== 'object' || target === null) return source as T;
    const output = { ...target };
    for (const key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        const sourceValue = source[key];
        if (
          sourceValue !== undefined &&
          sourceValue !== null &&
          typeof sourceValue === 'object' &&
          !Array.isArray(sourceValue)
        ) {
          (output as any)[key] = deepMerge((target as any)[key], sourceValue);
        } else if (sourceValue !== undefined) {
          (output as any)[key] = sourceValue;
        }
      }
    }
    return output;
  }

export function getAlias(): string {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'unknown';
  }
  return hostname.split('.')[0];
} 